module.exports = __webpack_public_path__ + "img/m-banner-cjizfoaj-ru-RU.df7b6ea4.png";